<template>
  <v-app dark>     
    <v-content class="blue darken-4">                
      <v-container fluid fill-height>          
        <v-layout column justify-center align-center>

            <v-spacer></v-spacer>          

            <v-flex row xs12 sm8 md4>

                <div class="mb-5">
                  <v-alert :value="error" outline color="white" icon="warning">
                    <div v-if="error === 'The password is invalid or the user does not have a password.'">
                      {{ $t('message.the_password_is_invalid_or_the_user_does_not_have_a_password') }}
                    </div>
                    <div v-else-if="error === 'The email address is badly formatted.'">
                      {{ $t('message.the_email_address_is_badly_formatted') }}
                    </div>
                    <div v-else-if="error === 'There is no user record corresponding to this identifier. The user may have been deleted.'">
                      {{ $t('message.there_is_no_user_record_corresponding_to_this_identifier_the_user_may_have_been_deleted') }}
                    </div>
                    <div v-else>
                      {{ error }}
                    </div>
                  </v-alert>
                </div>
                <form @submit.prevent="onSignin">
                  <div class="mb-4">
                    <h2 class="display-2">{{ $t('message.inobram_plataform') }}</h2>
                  </div>

                  <v-text-field                    
                      name="email"
                      label="Email"
                      id="email"
                      type="text"
                      v-model="email"
                      required>
                  </v-text-field>
                  <v-text-field
                      name="password"
                      :label="passwordLabel"
                      id="password"
                      type="password"
                      v-model="password"
                      required>
                  </v-text-field>

                  <v-btn 
                    color="info" 
                    type="submit" 
                    class="margin-zero"
                    :loading="$store.getters.loading && !error"
                  >
                    {{ $t('message.enter') }}
                  </v-btn>

                </form>                    

            </v-flex>    

            <v-spacer></v-spacer>

            <v-footer class="blue darken-4">
                  <div class="some-margin use-hand-cursor">
                    <v-tooltip top>
                      <img src="/static/img/flag-of-Brazil1.png"
                        alt="Brazil flag" width="26" height="18"
                        slot="activator"
                        @click="changeLanguage('pt_BR')"
                      >
                      <span>Português</span>
                    </v-tooltip>
                  </div>

                  <div class="some-margin use-hand-cursor">
                    <v-tooltip top>
                      <img src="/static/img/flag-of-United-States-of-America1.png"
                        alt="United States of America flag" width="26" height="18"
                        slot="activator"
                        @click="changeLanguage('en_US')"
                      >
                      <span>English</span>
                    </v-tooltip>
                  </div>
                  
                  <div class="some-margin use-hand-cursor">
                    <v-tooltip top>
                      <img 
                        src="/static/img/flag-of-Spain1.png"
                        alt="Spain flag" width="26" height="18"
                        slot="activator"
                        @click="changeLanguage('es_ES')"
                      >
                      <span>Español</span>
                    </v-tooltip>
                  </div>
            </v-footer>          

        </v-layout>
        
      </v-container>
    </v-content>
    
  </v-app>
</template>

<script>
export default {
  data () {
    return {
      passwordLabel: this.$t('message.password'),
      email: '',
      password: ''
    }
  },
  computed: {
    user () {
      return this.$store.getters.user
    },
    error () {
      return this.$store.getters.error
    },
    locale: function () {
      return this.$store.getters.language
    }
  },
  watch: {
    user (value) {
      if (value !== null && value !== undefined) {
        this.$router.push('/')
      }
    },
    locale: function (value) {
      this.passwordLabel = this.$t('message.password')
    }
  },
  methods: {
    onSignin () {
      this.$store.dispatch('signUserIn', {
        email: this.email, password: this.password})
    },
    changeLanguage (language) {
      this.$i18n.locale = language
      this.$store.dispatch('setLanguage', language)
    }
  }
}
</script>

<style scoped>

  .margin-zero {
    margin-left: 0px !important;
  }

  .some-margin {
    margin-top: 8px;
    margin-right: 5px;
  }  

  .use-hand-cursor {
    cursor: pointer;
  }


</style>


// WEBPACK FOOTER //
// src/components/Auth/Signin.vue